import quoteCarousel from '../../components/quoteCarousel.js';

new quoteCarousel(document.querySelector('[data-quote-carousel]'));
